import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';

// type TypeDetailsKeys = keyof ISupplier['typeDetails']
// type RenderSections = keyof ISupplier['typeDetails'][TypeDetailsKeys];

// const extraSections: Record<keyof ISupplier['typeDetails'], { renderSections: RenderSections[] }> = {
const extraSections: Record<
  keyof ISupplier['typeDetails'],
  { renderSections: string[]; [x: string]: any }
> = {
  beauty: {
    renderSections: ['productsServices'],
  },
  cakes: {
    renderSections: ['generalServices', 'dietaryOptions'],
  },
  catering: {
    renderSections: ['generalServices', 'foodType', 'dietaryOptions'],
  },
  decoration: {
    renderSections: ['productsServices'],
  },
  dress: {
    renderSections: ['productsServices'],
  },
  entertainment: {
    renderSections: ['productsServices'],
  },
  florist: {
    renderSections: ['productsServices'],
  },
  group: {
    renderSections: [],
  },
  jewellery: {
    renderSections: ['productsServices'],
  },
  marquee: {
    renderSections: ['productsServices'],
  },
  menswear: {
    renderSections: ['productsServices'],
  },
  music: {
    renderSections: ['businessType', 'musicStyle', 'instruments', 'additionalServices'],
  },
  photo: {
    renderSections: ['productsServices', 'photographyStyle'],
  },
  planners: {
    renderSections: ['productsServices'],
  },
  stationery: {
    renderSections: ['productsServices'],
  },
  transport: {
    renderSections: ['productsServices'],
  },
  venue: {
    renderSections: ['details', 'ceremonyReception', 'foodDrink', 'tags'],
    overviewSection: {
      exclusiveUse: false,
      weddingLicence: false,
      hasAccommodation: false,
      lateNightExtensionAvailable: false,
      alcoholLicense: false,
    },
    venueFeatures: {
      churchWithinWalkingDistance: false,
      disabledAccess: false,
      marqueePermitted: false,
    },
  },
  video: {
    renderSections: ['productsServices'],
  },
};

export default extraSections;
